import { ReactElement, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import { RouteProp } from '@/propTypes'
import { NavigatorButton } from '../../atoms'

import env from '@/lib/env'

import Container from './style'
import { useHooks } from './methods'

interface Props {
  routes: Route[]
  style?: CSSProperties
  className?: string
  id?: string
}

function NavigatorGroup({ id, className, style, routes }: Props): ReactElement {
  const { nextRoute } = useHooks()

  return (
    <Container id={id} className={className} style={style}>
      {routes.map((route: Route) => (
        <NavigatorButton
          key={`${route.pathname}-${route.hash}`}
          href={route.pathname}
          hash={route.hash}
          isSelected={nextRoute.pathname === route.pathname}
        >
          {route.name}
        </NavigatorButton>
      ))}
      <a
        className="platform-link-button"
        href={env.PLATFORM_URL}
        rel="noreferrer"
        target="_blank"
      >
        เข้าสู่ระบบ
      </a>
    </Container>
  )
}

NavigatorGroup.propTypes = {
  routes: PropTypes.arrayOf(RouteProp).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

NavigatorGroup.defaultProps = {
  className: '',
}

export default memo(NavigatorGroup)
